import { render } from "./reject_process.vue?vue&type=template&id=70be77ba"
import script from "./reject_process.vue?vue&type=script&lang=js"
export * from "./reject_process.vue?vue&type=script&lang=js"

import "./reject_process.vue?vue&type=style&index=0&id=70be77ba&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__